var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import { css } from 'styled-components';
import defaultStyle from './sharedTextStyle';

var textStyle = function textStyle(type) {
  return function () {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n    ", ";\n    ", "\n  "])), defaultStyle(type), function (_ref) {
      var numberOfLines = _ref.numberOfLines;
      return "\n    " + (numberOfLines ? "\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        -webkit-line-clamp: " + numberOfLines + ";\n        overflow: hidden;\n      " : '') + "\n  ";
    });
  };
};

export default textStyle;